import { DEFAULT_CATALOGUE_DESIGN, type CatalogueDesignKey } from '@eshop/designs';

import './registerDefaultTemplates';

import type { CatalogueTemplate } from './types';
import { templateRegistry } from './system/TemplateRegistry';
import type { VisualTemplate } from './system/templateTypes';

export interface LoadCatalogueTemplateOptions {
  design?: CatalogueDesignKey;
  fallbackDesign?: CatalogueDesignKey;
}

export async function loadCatalogueTemplate(
  name: string,
  { design, fallbackDesign = DEFAULT_CATALOGUE_DESIGN }: LoadCatalogueTemplateOptions = {},
): Promise<CatalogueTemplate> {
  const baseTemplate = await templateRegistry.loadCatalogueTemplate(name);
  const resolved: CatalogueTemplate = { ...baseTemplate };

  if (design) {
    try {
      const visualTemplate = await templateRegistry.resolveTemplate(design, fallbackDesign);
      Object.assign(resolved, { visualTemplate });
    } catch (error) {
      if (process.env.NODE_ENV !== 'production') {
        console.warn('No se pudo resolver VisualTemplate, se usará configuración base.', error);
      }
    }
  }

  return resolved;
}

export const registerTemplate = (
  key: CatalogueDesignKey,
  template: VisualTemplate | (() => VisualTemplate | Promise<VisualTemplate>),
) => templateRegistry.registerTemplate(key, template);

export const resolveTemplate = (
  designKey: CatalogueDesignKey,
  fallbackKey?: CatalogueDesignKey,
) => templateRegistry.resolveTemplate(designKey, fallbackKey);

export const preloadTemplate = (designKey: CatalogueDesignKey) =>
  templateRegistry.preloadTemplate(designKey);

export const listCatalogueTemplates = () => templateRegistry.listCatalogueTemplates();
